import * as prettier from 'prettier';
import type { Lang } from '.';
import { Ok } from '../blocks/ts/result';
const format: Lang['format'] = async (code, { formatter, prettierOptions, filePath }) => {
	if (!formatter) return code;

	if (formatter === 'prettier') {
		return await prettier.format(code, {
			parser: 'markdown',
			filepath: filePath,
			...prettierOptions
		});
	}

	return code;
};

/** Language support for `*.(md)` files. */
export const markdown: Lang = {
	matches: (fileName) => fileName.endsWith('.md'),
	resolveDependencies: () => Ok({ dependencies: [], local: [], devDependencies: [], imports: {} }),
	// comment: (content) => `<!--\n${lines.join(lines.get(content), { prefix: () => '\t' })}\n-->`,
	format
};
